import type { DragEvent } from 'react';

export interface IMouseDownProps {
    event: DragEvent,
    isEditing?: boolean
    dragStart: (event: MouseEvent, startMousePosition: IPosition) => void;
    onDrag: (event: MouseEvent) => void;
    dragEnd: (event: MouseEvent) => void;
}

export interface IPosition {
    x: number,
    y: number
}

/**
 * 通用拖拽逻辑
 */
export default class BaseDragLogic {
    /**
     * 开始拖拽时间
     */
    private dragStartTime: number | null;
    /**
     * 拖拽开始鼠标坐标
     */
    private startMousePosition: any;
    /**
     * 鼠标mousedown的props
     */
    private mouseDownProps: IMouseDownProps;

    /**
     * 开始拖拽
     * @param event
     * @param element
     * @param scale
     */
    protected startDrag(props: IMouseDownProps) {
        this.dragStartTime = Date.now();
        this.startMousePosition = this.getEventCoordinates(props.event);
        this.mouseDownProps = props;
    }

    /**
     * 拖拽结束
     * @param event
     */
    protected stopDrag = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        if (!this.dragStartTime) {
            this.mouseDownProps.dragEnd(event);
        }
        this.startMousePosition = null;
    };

    /**
     * 鼠标移动处理
     * @param event
     */
    protected handleMove = (event: MouseEvent, delayTime: number) => {
        const coords = this.getEventCoordinates(event);
        if (this.checkDelayTimeAndCoords(delayTime, coords)) {
            this.dragStartTime = null;
            this.mouseDownProps.dragStart(event, this.startMousePosition);
        } else if (!this.dragStartTime) {
            event.stopPropagation();
            this.mouseDownProps.onDrag(event);
        }
    };

    /**
     * 获取事件坐标
     * @param e
     */
    private getEventCoordinates = (e: any): IPosition => {
        const event = e.nativeEvent || e;
        return {
            x: event?.touches?.[0] ? event.touches[0].clientX : event.clientX,
            y: event?.touches?.[0] ? event.touches[0].clientY : event.clientY,
        };
    };

    private checkDelayTimeAndCoords(delayTime: number, coords: { x: any; y: any }) {
        return this.dragStartTime
            && Date.now() - this.dragStartTime > delayTime
            && (coords.x !== this.startMousePosition.x
                || coords.y !== this.startMousePosition.y);
    }
}
